<template>
    <span @click="onClick" class="discount-button" :class="{ active: isActive }">%</span>
</template>

<script setup lang="ts">
    import { useCartStore } from "@/data/stores/cart";
    import { computed } from "vue";

    const cart = useCartStore();

    const emit = defineEmits<{ (e: "onClick"): void }>();

    // define computed
    const isActive = computed(() => cart.isAnyCartItemSelected);

    function onClick() {
        if (isActive.value) {
            emit("onClick");
        }
    }
</script>

<style scoped lang="scss">
    @use "./../../../../assets/styles/scss/shared/_colors.scss";
    @use "./../../../../assets/styles/scss/shared/_mixins.scss";
    @use "./../../../../assets/styles/scss/shared/_variables.scss";

    .discount-button {
        display: inline-block;
        font-size: 16px;
        color: colors.$white;
        background-color: colors.$dark-gray-100;
        border-radius: 0.3125em;
        padding: 0.375em 0.75em;
        cursor: default;
        transition: background-color 0.3s variables.$easeOutExpo;

        -webkit-box-shadow: 1px 1px 1px 0px colors.$dark-gray-400;
        -moz-box-shadow: 1px 1px 1px 0px colors.$dark-gray-400;
        box-shadow: 1px 1px 1px 0px colors.$dark-gray-400;

        &.active {
            background-color: colors.$green;
            cursor: pointer;

            @include mixins.hover-and-active() {
                background-color: colors.$greenHover;
            }
        }
    }
</style>
